import { useContext } from 'react';
import { ContactContext } from 'src/contexts/contacts/contactContext';

export const useContact = () => useContext(ContactContext);
